import { environment } from './environments/environment';

const sentryConfig = environment.sentry;

export const enableSentry = sentryConfig.dsn && sentryConfig.dsn !== '{SENTRY_DSN}';
